<template>
    <div>
        <b-row>
            <b-col>
                <b-card no-body>
                    <b-card-header>
                        <strong>Missing Travel</strong>
                    </b-card-header>
                    <b-card-body>
                        <b-row>
                            <b-col>
                                <p>
                                    The Missing Travel Export provides a list of participants
                                    who are currently pending a decision on room and airfare reservations.
                                    <br>
                                    The list is also displayed on the Travel page
                                    which is accessible from the Administration menu.
                                </p>
                            </b-col>
                        </b-row>
                    </b-card-body>
                    <b-card-footer class="clearfix">
                        <b-button-group size="sm">
                            <b-button variant="success" @click="doExport">Export</b-button>
                        </b-button-group>
                    </b-card-footer>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>


<script>
import { Component, Vue } from 'vue-property-decorator';
import Breadcrumb from '@/views/menu/breadcrumb/breadcrumb';
import download from '@/util/downloader';
import {errorModalOptions} from "../../../../util/formatters";


@Component
export default class MissingTravel extends Vue {
    async doExport() {
        try {
            await download('POST', '/api/v1/export/missing-travel', JSON.stringify({}));
        }
        catch (error) {
            await this.$bvModal.msgBoxOk(error.message, errorModalOptions);
        }
    }

    async mounted() {
        this.$store.commit('addBreadcrumb', Breadcrumb.create('Missing Travel', null, true));
    }
}
</script>


<style scoped>

</style>